// removed by extract-text-webpack-plugin
module.exports = {"setting_top_middle":"_1ovuFQXMIPj9QsNSAbZZct","setting_bottom_right":"_3NEK1wIVYYoGC6B9O9HXVm","setting_bottom":"_1vKsnEbz_UriIQeHnJwzo0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TripAdvisor/SettingsComponent.css
// module id = 452
// module chunks = 0